export default __webpack_public_path__ + "static/media/emoji-chat.e5d37c7f.svg";